import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Config from '../server.json'; 

const ShowOrdinances = () => {
  const { ordno } = useParams();
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${Config.ORDINANCE_DETAIL_API_URL}?ordno=${encodeURIComponent(ordno)}`)
      .then(res => res.json())
      .then(data => {
        setMeta(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [ordno]);

  const pdfUrl = `${Config.ORDINANCEPDF_DETAIL_API_URL}?ordno=${encodeURIComponent(ordno)}`;


  if (loading) {
    return <p className="p-4 text-center">Loading…</p>;
  }

  if (!meta || meta.status === 'error') {
    return (
      <div className="p-4">
        <Link to="/ordinances" className="text-blue-600 hover:underline">
          ← Back to list
        </Link>
        <p className="mt-4 text-red-500">Failed to load ordinance details.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow">
     
        <h1 className="text-2xl font-bold mb-2">
          {meta.OrdNo} <br></br>
           {meta.Title}
        </h1>
        <p className="text-sm text-gray-500 mb-4">Date Enacted: {meta.DateAdopted}</p>

        <iframe
  src={pdfUrl}
  title={`Ordinance ${ordno}`}
  className="w-full h-full border"
  style={{ height: '100vh', width: '100%' }}
/>

      </div>
    </div>
  );
};

export default ShowOrdinances;
